import React, { useEffect, useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { emitter } from "../utils/editorUtils/editorUtils.js";
import "react-loading-skeleton/dist/skeleton.css";
import approvedIcon from "../images/status_approved.svg";
import threeDotIcon from "../images/kababButton.svg";
import MLRStatusGreen from "../images/MLR StatusGreen.png";
import MLRStatusGray from "../images/MLR StatusGray.png";
import MLRStatusRed from "../images/MLR StatusRed.png";
import MLRWarning from "../images/MLR-Warning-Grey.svg";
import MLRExpired from "../images/MLR-Expired.svg";
import MLROrange from "../images/MLRStatus-Intermediate-Orange.svg";
import MLRDraft from "../images/MLR_Draft.svg";
import MLRGreen from "../images/MLR-GreenTick.svg";
import WarningRedIcon from "../images/warning-red-icon.svg";
import progressAnimation from "../images/progress-round.gif";
import MLRStatusOrange from "../images/common_status.svg";
import refreshIcon from "../images/gilead-refresh-icon.svg";
import expiredRestrictedIcon from "../images/expired-restriction-icon.svg";
import expiredRestrictedIconWhite from "../images/expired-restriction-icon-white.svg";
import previewEyeIcon from "../images/preview-eye-icon.svg";
import LockIcon from "../images/lockedOnCards.svg";
import { setEdtailData, daysAgoCreated } from "../utils";
import useVisible from "../pages/ShowPopover";
import ValueContext from "../utils/contextAPI/contextAPI";
import { eDetail, template } from "../utils/constants";
import PreviewModal from "./Preview/Preview";
import { geteDetailByID, getMLRStatus } from "../services/apis";
import { ExportDeckToMail, getMarketDetails } from "../services/apis";
import CircularProgressBar from "../utils/CircularProgressBar";
import CloseIcon from "../images/Close-Small.svg";
import ErrorIcon from "../images/Error-Icon.svg";
import TimeIcon from "../images/time-icon.svg";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import "../css/editor.scss";
import "../css/newBannerDesign.scss";
import { ThreeDotIcon } from "./ThreeDotComponent/ThreeDotIcon";
import { showErrorToast } from "./toastComponent/ToastComponent.js";
import autoGeneratedIcon from "../images/auto-generated-icon.svg";

function BannerCard(props) {
  const {
    cardData,
    // edetail
    openCloneEdetailModal,

    deleteEdetailCard,
    type,
    filterName,
    openCloneTemplateModal,
    handleDeletetemplate,
    handleExport,
    setSelectedCard,
    setDisabledBtn,
    handleExportModal,
    clicKRsdPreview,
    showFetchedResults,
    selectedCardList,
    setSelectedCardList,
    selectedCard,
    setshowFetchedResults,
    lockTemplate,
    createdbyMe,
    cardDetailsHandler,
    imageKey,
    expireTemplateHandler,
    brands,
    countriesList,
  } = props;
  const { ref, kababMenu, setKababMenu } = useVisible(false);
  const navigate = useNavigate();
  const appData = useContext(ValueContext);
  const cardRef = useRef();
  const [isActive, setIsActive] = useState(false);

  var [showPreviewModal, setShowPreviewModal] = useState(false);
  const [deckDetails, setDeckDetails] = useState({});
  // let showPreviewModal = false;
  const [canvasHeight, setCanvasHeight] = useState();
  const [appDataTemp, setAppDataTemp] = useState({});
  const [previewResp, setPreviewResp] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [imageLoader, setImageLoader] = useState(true);
  const [currentUserId, setCurrentUserId] = useState("");
  const [veevaStatus, setVeevaStatus] = useState();
  const [docLink, setDockLink] = useState();
  const [exportJobIndex, setExportJobIndex] = useState(0);
  const [cardDataExportIndex, setCardExportIndex] = useState(0);

  useEffect(() => {
    setImageLoader(true);
    const docLinks = cardData?.veevaMetadata?.filter(
      (li) => li.assetType === 1
    );
    if (docLinks) {
      setDockLink(docLinks);
    }
    if (
      cardData?.exportJob?.findIndex(
        (el) => el.userId === cardData.created.userid
      ) > 0
    ) {
      setCardExportIndex(
        cardData?.exportJob?.findIndex(
          (el) => el.userId === cardData.created.userid
        )
      );
    }
  }, [createdbyMe]);

  useEffect(() => {
    const user = localStorage?.getItem("userId") || "";
    setCurrentUserId(user);
  }, []);

  const getCurrentStatus = () => {
    setPreviewLoading(true);

    getMLRStatus(cardData._id, false, async (response, err, errorCode) => {
      if (err) {
        setPreviewLoading(false);
        if (typeof err.response.data.err === "string")
          showErrorToast("The document is not yet submitted");
        else showErrorToast("Something went wrong. Try again.!");
      } else {
        setPreviewLoading(false);
        let data = await response.data;

        let index = showFetchedResults.findIndex(
          (result) => result._id === cardData._id
        );
        let tempAllDecks = JSON.parse(JSON.stringify(showFetchedResults));
        cardData.veevaMetadata.filter(
          (asset) => asset.assetType === 1
        )[0].docStatus = data.response.docStatus;
        tempAllDecks[index] = cardData;
        // setshowFetchedResults(tempAllDecks);
        showFetchedResults[index] = cardData;
      }
    });
  };
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));
  const getAppData = async (id) => {
    setPreviewLoading(true);
    await geteDetailByID(
      // cardData.cardData._id,
      cardData._id,
      async (response, err, errorCode) => {
        if (err) {
          setPreviewLoading(false);
          showErrorToast(`Preview Failed. ${err}`);
          setShowPreviewModal(false);
          setPreviewResp(false);
        } else {
          let data = await response.data;
          setAppDataTemp({ ...appData, deckId: data });
          //setPreviewLoading(true);
          setShowPreviewModal(true);
          showPreviewModal = true;
          setPreviewResp(false);
          ExportDeckToMail(
            cardData._id,
            (response, err, errorCode) => {
              if (err) {
                setPreviewLoading(false);
                showErrorToast(`Preview Failed. ${err}`);
                setShowPreviewModal(false);
                setPreviewResp(false);
              } else {
                // setExportLoading(false);
                setShowPreviewModal(true);
                showPreviewModal = true;
                setPreviewResp(true);
                setPreviewLoading(false);
              }
            },
            "preview=true"
          );
        }
      }
    );
  };
  const goToEditor = () => {
    // if (showPreviewModal) {
    //   return;
    // }

    // Check if it's a PDF_TO_HTML card - navigate to PDF Editor
    if (isPdfToHtml) {
      navigate(`/pdf-editor/${cardData._id}`, {
        state: { deckData: cardData },
        replace: true,
      });
      appData.setDeckId(cardData);
    } else {
      // Regular editor navigation
      navigate(`editor/${cardData.slides[0]?.slideid._id}`, {
        state: { data: cardData },
        replace: true,
      });
      appData.setDeckId(cardData);
    }
    removecategoryType();

    window.localStorage.setItem("categoryType", type);
  };
  const removecategoryType = () => {
    window.localStorage.removeItem("categoryType");
  };

  // const exportEdetailCard = () => {};

  // const handleClickOutside = (event) => {
  //   if (event.target.tagName === "IMG") {
  //     if (cardRef.current && !cardRef.current.contains(event.target)) {
  //       setIsActive(false);
  //     } else {
  //       setIsActive((isActive) => !isActive);
  //     }
  //   } else {
  //   }
  // };

  // useEffect(() => {
  //   const closeKababMenu = (e) => {
  //     if (e?.path[0]?.tagName !== "IMG") setKababMenu(false);
  //   };
  //   document.body.addEventListener("click", closeKababMenu);
  //   document.addEventListener("click", handleClickOutside);
  //   return () => document.body.removeEventListener("click", closeKababMenu);
  // }, []);

  const setKababMenus = (e) => {
    /* setTimeout(() => {
      const menuPaper = document.querySelector(".newCard");
      if (menuPaper.classList.contains("animate")) {
        menuPaper?.classList?.remove("animate");
        menuPaper?.classList?.add("animate-remove");
      } else {
        menuPaper?.classList?.remove("animate-remove");
        menuPaper?.classList?.add("animate");
      }
    }); */
  };
  // console.log("sele", selectedCard);
  const handleSelectedCard = (card) => {
    // if (Object.keys(card).length !== 0) {
    //   setSelectedCard(card);
    //   setDisabledBtn(false);
    // } else {
    //   setDisabledBtn(true);
    // }
    // ;
    // if (!selectedCard.includes(card)) {
    //   setSelectedCard([...selectedCard, card._id]);
    //   // setSelectedCard(card);
    // } else {
    //   let updatedList = selectedCard?.filter(function (item) {
    //     return item !== card._id;
    //   });
    //   setSelectedCard(updatedList);
    // }
    const index = selectedCard?.findIndex((item) => {
      return item === card._id;
    });
    if (index < 0) {
      let temSelectedCard = [card._id];
      //  temSelectedCard.push(card._id);
      setSelectedCard(temSelectedCard);
    } else if (index > -1) {
      setSelectedCard(
        [...selectedCard].filter((item) => {
          return item !== card._id;
        })
      );
    }
  };

  const gotoPreview = async () => {
    getAppData();
    // setPreviewLoading(true);
    // setShowPreviewModal(true);
    // showPreviewModal = true;
    // setPreviewResp(false);
    // ExportDeckToMail(
    //   cardData._id,
    //   (response, err, errorCode) => {
    //     if (err) {
    //       setPreviewLoading(false);
    //       setShowPreviewModal(false);
    //       setPreviewResp(false);
    //     } else {
    //       // setExportLoading(false);
    //       setShowPreviewModal(true);
    //       showPreviewModal = true;
    //       setPreviewResp(true);
    //       setPreviewLoading(false);
    //     }
    //   },
    //   "preview=true"
    // );
  };

  const imageLoaded = (thumbnail) => {
    if (thumbnail) {
      setImageLoader(false);
    } else {
      setImageLoader(true);
    }
  };

  const creationDay = () => {
    const createdOn = cardData?.created_at;
    return daysAgoCreated(createdOn);
  };
  const otherCountryStatus = ["DRAFT", "NOT SUBMITTED"];
  const spainCountryStatus = [
    "DRAFT",
    "NOT SUBMITTED",
    "REVIEWED WITH MINOR CHANGES",
    "APPROVED WITH MINOR CHANGES",
  ];
  const ValidateStatusCriteria = () => {
    let docstatus = false;
    const countryOther = countriesList?.find(
      ({ _id, name }) => _id === cardData?.market && name !== "Spain"
    );
    const countrySpain =
      countriesList?.find(
        ({ _id, name }) => _id === cardData?.market && name === "Spain"
      ) &&
      brands?.find(
        ({ _id, name }) => _id === cardData?.brand && name === "Biktarvy"
      );
    if (countryOther) {
      docstatus = otherCountryStatus?.includes(
        cardData?.veevaMetadata
          ?.filter((asset) => asset?.assetType === 1)[0]
          ?.docStatus.toUpperCase()
      );
    }
    if (countrySpain) {
      docstatus = spainCountryStatus?.includes(
        cardData?.veevaMetadata
          ?.filter((asset) => asset?.assetType === 1)[0]
          ?.docStatus.toUpperCase()
      );
    }
    setVeevaStatus(docstatus);
    // console.log('on click sttaus',countriesList, brands,cardData?.veevaMetadata?.filter((asset) => asset?.assetType === 1)[0]?.docStatus.toUpperCase() )
    // return docstatus;
  };

  // Check if card has PDF_TO_HTML tag
  const isPdfToHtml = cardData?.tags?.includes("PDF_TO_HTML");

  const moduleCardMenuOptions = [
    <li
      className="pl-0 pr-0"
      onClick={() => goToEditor()}
      style={{
        display: `${
          !cardData.expired && (veevaStatus || isPdfToHtml) ? "block" : "none"
        }`,
      }}
    >
      <button
        className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          goToEditor();
        }}
      >
        {"Edit"} {}
      </button>
    </li>,
    <li
      className="pl-0 pr-0"
      style={{
        display: `${!cardData.expired && !isPdfToHtml ? "block" : "none"}`,
      }}
    >
      <button
        className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          appData.setDeckId(cardData);
          handleExportModal(cardData);
        }}
      >
        {/* {"Export"} */}
        Generate RSD
      </button>
    </li>,

    <li className="pl-0 pr-0">
      <button
        className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          cardDetailsHandler(cardData._id, cardData);
        }}
      >
        {"Details"}
      </button>
    </li>,

    <li
      className="pl-0 pr-0"
      style={{ display: `${!isPdfToHtml ? "block" : "none"}` }}
    >
      <button
        className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          openCloneEdetailModal(cardData._id);
        }}
      >
        {"Make a Copy"}
      </button>
    </li>,

    // <li
    //   className="pl-0 pr-0"
    //   style={{
    //     display: `${
    //       createdbyMe === "me" || cardData?.created?.userid === currentUserId && !cardData.expired ? "block" : "none"
    //     }`,
    //   }}
    // >
    //   <button
    //     className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
    //     onClick={(e) => expireTemplateHandler(cardData, type)}
    //   >
    //     {"Expire"}
    //   </button>
    // </li>,
  ];
  const moduleCardMenuOptionsTemplate = [
    /*  ValidateStatusCriteria() &&   */ <li
      className="pl-0 pr-0"
      style={{
        display: `${
          (veevaStatus || isPdfToHtml) &&
          !cardData.expired &&
          (createdbyMe === "me" ||
            cardData?.created?.userid === currentUserId ||
            !cardData.locked)
            ? "block"
            : "none"
        }`,
      }}
    >
      <button
        className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => goToEditor()}
      >
        {"Edit"}
      </button>
    </li>,
    // <li
    //   className="pl-0 pr-0"
    //   style={{
    //     display: `${
    //       !cardData.locked && !cardData.expired && veevaStatus
    //         ? "block"
    //         : "none"
    //     }`,
    //   }}
    // >
    //   <button
    //     className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
    //     onClick={() => goToEditor()}
    //   >
    //     {"Edit"}
    //   </button>
    // </li>,
    <li
      className="pl-0 pr-0"
      style={{ display: `${!cardData.expired ? "block" : "none"}` }}
    >
      <button
        className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={(e) => openCloneTemplateModal(cardData._id)}
      >
        {"Copy"}
      </button>
    </li>,
    <li
      className="pl-0 pr-0"
      style={{
        display: `${!cardData.expired ? "block" : "none"}`,
      }}
    >
      <button
        className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          appData.setDeckId(cardData);
          handleExportModal(cardData);
        }}
      >
        {/* {"Export"} */}
        Generate RSD
      </button>
    </li>,

    <li
      className="pl-0 pr-0"
      style={{
        display: `${
          createdbyMe === "me" ||
          (cardData?.created?.userid === currentUserId && !cardData.expired)
            ? "block"
            : "none"
        }`,
      }}
    >
      <button
        className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          lockTemplate(cardData);
        }}
      >
        {cardData?.locked ? "Unlock" : "Lock"}
      </button>
    </li>,
    <li className="pl-0 pr-0">
      <button
        className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          cardDetailsHandler(cardData._id, cardData);
        }}
      >
        {"Details"}
      </button>
    </li>,
    // <li
    //   className="pl-0 pr-0"
    //   style={{
    //     display: `${
    //       createdbyMe === "me" || cardData?.created?.userid === currentUserId && !cardData?.locked && !cardData.expired
    //         ? "block"
    //         : "none"
    //     }`,
    //   }}
    // >
    //   <button
    //     className="btn btn-link p-0 m-0 w-100 text-left pr12 pl12 lh32"
    //     onClick={(e) => expireTemplateHandler(cardData, type)}
    //   >
    //     {"Expire"}
    //   </button>
    // </li>,
  ];

  const validStatusRegex = (status) => {
    const regex = /^(Approved for (Use|Production))$/i;
    const countryValidRegex = /^(GRC Process Complete)$/i;
    if (regex.test(status) || countryValidRegex.test(status)) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    const handleFooEvent = (e) => {
      const parsedData = JSON.parse(e);
      if (parsedData.type === "export_status_update") {
        try {
          if (parsedData.deckId || parsedData.deckid) {
            let data = parsedData;
            const idDeck = parsedData.deckId || parsedData.deckid;
            let index = showFetchedResults.findIndex(
              (result) => result._id === idDeck
            );
            let tempAllDecks = JSON.parse(JSON.stringify(showFetchedResults));

            if (parsedData.docStatus)
              tempAllDecks[index].veevaMetadata.filter(
                (asset) => asset.assetType === 1
              )[0].docStatus = parsedData.docStatus;

            if (parsedData.status !== "") {
              const obj = [
                {
                  status: parsedData.status,
                  fileUrl: parsedData.fileUrl,
                },
              ];
              const exportJobIndex =
                tempAllDecks[index]?.hasOwnProperty("exportJob") &&
                tempAllDecks[index]["exportJob"]?.findIndex(
                  (temp) =>
                    temp.userId ===
                    (parsedData.userId || cardData.created.userid)
                );
              if (
                tempAllDecks[index]?.hasOwnProperty("exportJob") &&
                tempAllDecks[index]["exportJob"]?.length > 0
              ) {
                tempAllDecks[index]["exportJob"][exportJobIndex] = {
                  ...tempAllDecks[index]["exportJob"][exportJobIndex],
                  status: parsedData.status,
                  fileUrl: parsedData.fileUrl,
                };
              } else {
                tempAllDecks[index]["exportJob"] = [parsedData];
              }

              setExportJobIndex(exportJobIndex > 0 ? exportJobIndex : 0);
              // cardData.exportJob = tempAllDecks[index]["exportJob"];
            }

            showFetchedResults[index] = tempAllDecks[index];
            console.log("------------", tempAllDecks);
            setshowFetchedResults(tempAllDecks);
          }
        } catch (error) {
          console.error("Received non-JSON message:", error);
        }
      }
    };

    //emitter.on("autoSync", handleFooEvent);
    emitter.on("autoSync", (data) => {
      handleFooEvent(data);
    });

    /* return () => {
      emitter.off("autoSync", (data) => {
        handleFooEvent(data);
      });
    }; */
  }, []);

  const ReviewRSd = () => {
    window.open(
      cardData.hasOwnProperty("exportJob") &&
        cardData?.exportJob.length > 0 &&
        cardData?.exportJob[cardDataExportIndex || 0]?.fileUrl,
      "_blank",
      "noopener,noreferrer"
    );
  };
  const statusList = {
    in_progress: "Generating",
    failed: "Failed",
    completed: "Generated",
    queued: "Generating",
  };
  return (
    <>
      {previewLoading && (
        <CircularProgressBar
          isloading={previewLoading}
          setIsloading={setPreviewLoading}
        />
      )}
      {
        <div className="card-holder-div">
          <div className="cards-container ">
            <div className="img-container">
              {isPdfToHtml && (
                <div className="auto-generated-tag">
                  <img src={autoGeneratedIcon} className="auto-generated-img" />
                  Auto-Generated
                </div>
              )}
              <img
                src={
                  cardData?.slides[0]?.slideid?.thumbnailNew?.trim()
                    ? `${cardData?.slides[0]?.slideid?.thumbnailNew}?n=${imageKey}` //cardData?.slides[0]?.slideid?.thumbnail
                    : cardData?.slides[0]?.slideid?.thumbnail?.trim()
                    ? `${cardData?.slides[0]?.slideid?.thumbnail}?n=${imageKey}`
                    : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/9WMiG4AAAAASUVORK5CYII="
                }
                alt=""
                key={imageKey}
                className={`img-overlay card-img ${
                  cardData.expired ? "img-grayScale" : ""
                }`}
                ref={cardRef}
                onLoad={() =>
                  imageLoaded(cardData?.slides[0]?.slideid?.thumbnailNew)
                }
              />
            </div>
            <div className="cards-details">
              <div className="d-flex align-items-center">
                <div>
                  <LightTooltip
                    className="mlrToolTip"
                    title={
                      cardData?.veevaMetadata?.length > 0
                        ? cardData?.veevaMetadata.filter(
                            (asset) => asset.assetType === 1
                          )[0].docStatus
                        : "Not Submitted"
                    }
                    arrow
                  >
                    <img
                      height={16}
                      src={
                        validStatusRegex(
                          cardData?.veevaMetadata.filter(
                            (asset) => asset.assetType === 1
                          )[0]?.docStatus
                        )
                          ? MLRGreen
                          : cardData?.veevaMetadata.filter(
                              (asset) => asset.assetType === 1
                            )[0]?.docStatus === "Draft"
                          ? MLRDraft
                          : cardData?.veevaMetadata.filter(
                              (asset) => asset.assetType === 1
                            )[0]?.docStatus === "Not Submitted"
                          ? MLRDraft
                          : cardData?.veevaMetadata.filter(
                              (asset) => asset.assetType === 1
                            )[0]?.docStatus === "Pending Withdrawal"
                          ? MLRWarning
                          : cardData?.veevaMetadata.filter(
                              (asset) => asset.assetType === 1
                            )[0]?.docStatus === "Withdrawn"
                          ? MLRWarning
                          : cardData?.veevaMetadata.filter(
                              (asset) => asset.assetType === 1
                            )[0]?.docStatus === "Expired"
                          ? MLRExpired
                          : cardData?.veevaMetadata?.length > 0
                          ? MLRStatusOrange
                          : MLRDraft
                      }
                      alt="MLR Icon"
                      className="statusIcon"
                    />
                  </LightTooltip>
                </div>
                <a
                  className={`module-list-card-moduleName ${
                    cardData?.veevaMetadata[0]?.docLink && "hyper-d-link"
                  }`}
                  href={cardData?.veevaMetadata[0]?.docLink}
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  {(cardData &&
                    cardData?.veevaMetadata &&
                    cardData?.veevaMetadata?.filter(
                      (asset) => asset.assetType === 1
                    )[0]?.docNumber) ||
                    "-"}
                </a>
                {/* <p className="module-list-card-moduleName">{cardData?.veevaMetadata.filter((asset)=>asset.assetType === 1)[0]?.docNumber||"-"}</p> */}
                <img
                  src={refreshIcon}
                  alt="refreshIcon"
                  onClick={() => getCurrentStatus()}
                  className="refreshIcon"
                />
              </div>
              <div className="d-flex align-items-center">
                <h4 className="module-list-card-product-name">Name </h4>
                <h4 className="separator-colon">:</h4>
                <h2 className="module-list-card-product-content">
                  {cardData?.name.length > 14 ? (
                    <LightTooltip
                      className="mlrToolTip"
                      title={cardData?.name}
                      arrow
                    >
                      <span>{cardData?.name}</span>
                    </LightTooltip>
                  ) : (
                    cardData?.name
                  )}
                </h2>
              </div>
              <div className="d-flex align-items-center">
                <h4 className="module-list-card-product-name">Product</h4>
                <h4 className="separator-colon">:</h4>
                <h2 className="module-list-card-product-content">
                  <LightTooltip
                    className="mlrToolTip"
                    title={
                      brands?.filter(
                        (brand) => brand?._id === cardData?.brand
                      )[0]?.name || ""
                    }
                    arrow
                  >
                    <span>
                      {brands?.filter(
                        (brand) => brand?._id === cardData?.brand
                      )[0]?.name || ""}
                    </span>
                  </LightTooltip>
                </h2>
              </div>
              <div className="d-flex align-items-center" style={{visibility: isPdfToHtml ? 'hidden':'visible'}}>
                <h4 className="module-list-card-product-name">RSD Status </h4>
                <h4 className="separator-colon">:</h4>
                <h2 className="module-list-card-product-content rsd-block">
                  {cardData.hasOwnProperty("exportJob") &&
                    cardData?.exportJob?.length > 0 &&
                    cardData?.exportJob[cardDataExportIndex || 0]?.status ===
                      "failed" && (
                      <img width={10} height={10} src={WarningRedIcon} />
                    )}
                  {cardData.hasOwnProperty("exportJob") &&
                  cardData?.exportJob?.length > 0 ? (
                    <span
                      className={`status-Update ${
                        cardData?.exportJob[cardDataExportIndex || 0]
                          ?.status === "failed"
                          ? "failed"
                          : ""
                      }`}
                    >
                      {statusList[
                        cardData?.exportJob[cardDataExportIndex || 0]?.status
                      ] === "Generating" && (
                        <img src={progressAnimation} />
                      )}{" "}
                      {
                        statusList[
                          cardData?.exportJob[cardDataExportIndex || 0]?.status
                        ]
                      }
                    </span>
                  ) : (
                    "Not Generated"
                  )}

                  {cardData.hasOwnProperty("exportJob") &&
                    cardData?.exportJob?.length > 0 &&
                    cardData?.exportJob[cardDataExportIndex || 0]?.status ===
                      "completed" && (
                      <span className="view-rsd" onClick={ReviewRSd}>
                        View RSD
                      </span>
                    )}
                </h2>
              </div>
              <div className="d-flex align-items-center created-time">
                <div className="time-icon-container">
                  <img
                    src={TimeIcon}
                    alt="refreshIcon"
                    className="refreshIcon"
                  />
                  <p className="module-list-card-product-name">
                    {creationDay()}
                  </p>
                </div>
                <div className="bannercard-content" style={{ display: "flex" }}>
                  {cardData?.locked && type === template && (
                    //<div style={{ width: "6%", paddingRight: "12px" }}>
                    <img
                      src={LockIcon}
                      height={16}
                      style={{
                        marginRight: "2px",
                        marginTop: "7px",
                        height: 16,
                        width: 15,
                      }}
                    />
                    //</div>
                  )}
                  {/* <img
                  src={threeDotIcon}
                  alt=""
                  onClick={(e) => {
                    setKababMenu(!kababMenu);
                    setKababMenus(e);
                  }}
                  className="bannercard-threedots"
                /> */}
                  <div>
                    {type === eDetail ? (
                      <ThreeDotIcon
                        validateStatus={ValidateStatusCriteria}
                        menuOptions={moduleCardMenuOptions}
                      />
                    ) : (
                      <ThreeDotIcon
                        validateStatus={ValidateStatusCriteria}
                        menuOptions={moduleCardMenuOptionsTemplate}
                      />
                    )}
                  </div>
                  {false && true ? (
                    <div className="bannercard-kabab-menu newCard" ref={ref}>
                      {/* <div className="triangle"></div> */}
                      {type === eDetail ? (
                        <ul>
                          {!cardData.expired && (
                            <li onClick={() => goToEditor()}>
                              <span>Edit</span>
                            </li>
                          )}
                          {!cardData.expired && (
                            <li
                              onClick={() => {
                                appData.setDeckId(cardData);
                                handleExportModal(cardData);
                              }}
                            >
                              {/* <span>Export</span> */}
                              <span>Generate RSD</span>
                            </li>
                          )}
                          {/* {createdbyMe && (
                              <li
                                onClick={() => deleteEdetailCard(cardData._id)}
                              >
                                <span>Delete</span>
                              </li>
                            )} */}
                          <li
                            onClick={() => {
                              cardDetailsHandler(cardData._id, cardData);
                            }}
                          >
                            <span>Details</span>
                          </li>
                          {createdbyMe && !cardData.expired && (
                            <li
                              onClick={(e) =>
                                expireTemplateHandler(cardData, type)
                              }
                            >
                              <span>Expire</span>
                            </li>
                          )}
                        </ul>
                      ) : (
                        <ul>
                          {createdbyMe && !cardData.expired && (
                            <li onClick={() => goToEditor()}>
                              <span>Edit</span>
                            </li>
                          )}
                          {!createdbyMe &&
                            !cardData.locked &&
                            !cardData.expired && (
                              <li onClick={() => goToEditor()}>
                                <span>Edit</span>
                              </li>
                            )}
                          {/* <li>
                        <span>Create </span>
                      </li>

                      <li>
                        <span>Review </span>
                      </li> */}
                          {!cardData.expired && (
                            <li
                              onClick={(e) =>
                                openCloneTemplateModal(cardData._id)
                              }
                            >
                              <span>Clone </span>
                            </li>
                          )}
                          {/* {createdbyMe && (
                              <li
                                onClick={(e) =>
                                  handleDeletetemplate(cardData._id)
                                }
                              >
                                <span>Delete </span>
                              </li>
                            )} */}
                          {!cardData.expired && (
                            <li
                              onClick={() => {
                                appData.setDeckId(cardData);
                                handleExportModal(cardData);
                              }}
                            >
                              {/* <span>Export </span> */}
                              <span>Generate RSD</span>
                            </li>
                          )}
                          {createdbyMe && !cardData.expired && (
                            <li
                              onClick={() => {
                                lockTemplate(cardData);
                              }}
                            >
                              {cardData?.locked ? (
                                <span>Unlock </span>
                              ) : (
                                <span>Lock </span>
                              )}
                            </li>
                          )}
                          <li
                            onClick={() => {
                              cardDetailsHandler(cardData._id, cardData);
                            }}
                          >
                            <span>Details</span>
                          </li>
                          {createdbyMe &&
                            !cardData?.locked &&
                            !cardData.expired && (
                              <li
                                onClick={(e) =>
                                  expireTemplateHandler(cardData, type)
                                }
                              >
                                <span>Expire </span>
                              </li>
                            )}
                        </ul>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className={`col-md-12 img-main`}>
            {/* imageLoader && (
              <Skeleton
                height="176"
                containerClassName="avatar-skeleton skelitonUI"
              />
            ) */
            /*  <span> Loading Image</span> */}
            {/* <img
                src={
                  cardData?.slides[0]?.slideid?.thumbnail !== ""
                    ? `${cardData?.slides[0]?.slideid?.thumbnail}?n=${imageKey}` //cardData?.slides[0]?.slideid?.thumbnail
                    : "https://fujifilm-x.com/wp-content/uploads/2019/08/x-t30_sample-images02.jpg"
                }
                //  src="https://fujifilm-x.com/wp-content/uploads/2019/08/x-t30_sample-images02.jpg"
                alt=""
                key={imageKey}
                className={`img-overlay card-img ${
                  cardData.expired ? "img-grayScale" : ""
                }`}
                
                ref={cardRef}
                onLoad={() =>
                  imageLoaded(cardData?.slides[0]?.slideid?.thumbnail)
                }
              /> */}
            {filterName !== "filter" && (
              <div
                className={`overlay ${
                  cardData.expired ? "previewHighlight" : ""
                }`}
                // onClick={() => {
                //   goToEditor();
                // }}
              >
                <div
                  className={`overlay-preview expiredPreviewBox `}
                  onClick={(e) => {
                    e.stopPropagation();
                    gotoPreview();
                  }}
                >
                  {" "}
                  {/* ${cardData.expired ? 'expiredPreviewBox' : ''} */}
                  <img
                    src={previewEyeIcon}
                    style={{ marginRight: "6px", marginTop: "-2px" }}
                    alt="preview"
                    title="preview"
                    width={12}
                    height={8}
                  />
                  <div
                    className={`preview expiredPreviewStyle`} /* ${cardData.expired ? 'expiredPreviewStyle' : ''} */
                  >
                    Preview
                  </div>
                </div>
              </div>
            )}

            {cardData.expired && (
              <>
                <div className="expired-card">
                  {/* <span className="expired-label-on-card">
                    <img src={expiredRestrictedIconWhite} className="expiredRestrictIconWhite" alt="expiredIcon" title="Expired" />Expired
                  </span> */}
                </div>
                <span className="expired-label-on-card">
                  <img
                    src={expiredRestrictedIconWhite}
                    className="expiredRestrictIconWhite"
                    alt="expiredIcon"
                    title="Expired"
                  />
                  Expired
                </span>
              </>
            )}
            {/* </Link> */}
          </div>
        </div>
      }
      {showPreviewModal && previewResp && (
        <PreviewModal
          showPreview={showPreviewModal}
          setShowPreView={setShowPreviewModal}
          deckData={cardData}
          slideID={appDataTemp.deckId.slides}
          currentSlide={{ master: appDataTemp.deckId.slides[0], child: {} }}
          lastChild={{}}
          inParent={{}}
          canvasHeight={canvasHeight}
          appData={appDataTemp}
          previewUrlReady={true}
        />
      )}
    </>
  );
}

export default BannerCard;
